module.exports = __WEBPACK_EXTERNAL_MODULE_240__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 240
// module chunks = 0